(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper')
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-template"]) return;
  try {
    
    const getpagi = document.querySelector('.AjaxinatePagination');
    if(typeof(getpagi) !== "undefined" && getpagi !== null){
      document.addEventListener("DOMContentLoaded", function() {
        const elem = getpagi.getAttribute('data-pagination');
        var endlessScroll = new Ajaxinate({
          container: '.AjaxinateLoop',
          pagination: '.AjaxinatePagination',
          loadingText: '<span class="loader-line"></span>',
          method: elem == 'scroll' ? 'scroll' : 'click'
        });
      });
    }
    
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
            if (window.SPR && theme.review ) {
              if ($('.shopify-product-reviews-badge').length > 0) {
                return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
              };
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 500px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-1"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    function initPhotoSwipeFromDOM(gallerySelector) {
      // Parse slide data (url, title, size ...) from DOM elements
      function parseThumbnailElements() {
        var thumbElements = Array.prototype.slice.call(document.querySelectorAll('.photo-image'));
        var items = [];

        thumbElements.forEach(function (figureEl) {
          if (figureEl.nodeType !== 1) return;

          var linkEl = figureEl.children[0];
          var size = linkEl.getAttribute('data-size') ? linkEl.getAttribute('data-size').split('x') : [];

          var item = {
            src: linkEl.getAttribute('href'),
            w: parseInt(size[0], 10) || 0,
            h: parseInt(size[1], 10) || 0,
            el: figureEl,
          };

          if (figureEl.children.length > 1) item.title = figureEl.children[1].innerHTML;
          if (linkEl.children.length > 0) item.msrc = linkEl.children[0].getAttribute('src');

          items.push(item);
        });

        return items;
      }

      function closest(el, fn) {
        return el && (fn(el) ? el : closest(el.parentNode, fn));
      }

      function onThumbnailsClick(e) {
        e = e || window.event;
        e.preventDefault();

        var clickedListItem = closest(e.target, function (el) {
          return el.tagName && el.tagName.toUpperCase() === 'FIGURE';
        });
        if (!clickedListItem) return;

        var clickedGallery = clickedListItem.parentNode;
        var childNodes = Array.prototype.filter.call(clickedGallery.childNodes, function (n) {
          return n.nodeType === 1;
        });
        var index = childNodes.indexOf(clickedListItem);

        if (index >= 0) openPhotoSwipe(index, clickedGallery);
        return false;
      }

      function photoswipeParseHash() {
        var hash = window.location.hash.substring(1),
          params = {};
        if (hash.length < 5) return params;
        hash.split('&').forEach(function (v) {
          var pair = v.split('=');
          if (pair.length >= 2) params[pair[0]] = pair[1];
        });
        if (params.gid) params.gid = parseInt(params.gid, 10);
        return params;
      }

      function openPhotoSwipe(index, galleryElement, disableAnimation, fromURL) {
        var pswpElement = document.querySelectorAll('.pswp')[0];
        var items = parseThumbnailElements();

        var options = {
          maxSpreadZoom: 1,
          bgOpacity: 0.7,
          zoomEl: true,
          history: false,
          pinchToClose: false,
          closeOnScroll: false,
          galleryUID: galleryElement.getAttribute('data-pswp-uid'),
        };

        if (fromURL) {
          if (options.galleryPIDs) {
            for (var j = 0; j < items.length; j++) {
              if (items[j].pid == index) {
                options.index = j;
                break;
              }
            }
          } else options.index = parseInt(index, 10) - 1;
        } else options.index = parseInt(index, 10);

        if (isNaN(options.index)) return;
        if (disableAnimation) options.showAnimationDuration = 0;

        var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
        gallery.init();
      }

      var galleryElements = document.querySelectorAll(gallerySelector);
      galleryElements.forEach(function (el, i) {
        el.setAttribute('data-pswp-uid', i + 1);
        el.onclick = onThumbnailsClick;
      });

      var hashData = photoswipeParseHash();
      if (hashData.pid && hashData.gid) openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true);
    }

    // Initialize PhotoSwipe
    initPhotoSwipeFromDOM('.my-gallery');
  });

  } catch(e) { console.error(e); }
})();
})();
